// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import '../static/fonts/fonts.css';
// 自定义封装的插件 loading
import hyLoading from './my_plugin/loading/index'
Vue.use(hyLoading)

import echarts from 'echarts'
import 'echarts/map/js/china.js' // 引入中国地图数据
// require('echarts/extension/bmap/bmap')

Vue.prototype.echarts = echarts

import tagCloud from 'v-tag-cloud'
Vue.use(tagCloud)


router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  // 根据path来匹配做一些需要的东西
  switch (to.path) {
    // case '/scene_operating':
    //   store.commit('setPageToggle',0)
    //   break
    // case '/scene_tourists':
    //   store.commit('setPageToggle',1)
    //   break
    // case '/satisfaction':
    //   store.commit('setPageToggle',2)
    //   break
  }
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js